module.exports = __webpack_public_path__ + "static/media/logo1.f8c2bf00.png";